import { computed } from 'vue'
import { useAppHeaderMetrics } from '~/composables/useAppHeaderMetrics'

/** Shared offset for fixed and teleported surfaces below the app header. */
export function useOverlayOffset() {
    const { headerBottom, contentHeight } = useAppHeaderMetrics()

    const overlayVariables = computed(() => ({
        '--app-overlay-top': `${headerBottom.value}px`,
        '--app-overlay-height': contentHeight.value,
    }))

    return { overlayVariables }
}
